import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = {
  key: 0,
  class: "section"
}
const _hoisted_7 = {
  key: 1,
  class: "report-chart"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_ISYChart = _resolveComponent("ISYChart")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ScoreYearChart = _resolveComponent("ScoreYearChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        (_ctx.filters.yearSeg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" Impact of Start Date ")
              ], -1),
              _createElementVNode("div", { class: "section-content" }, " IRRs vary over time. Viewing the experience of each joiner cohort helps understand pot adequacy at retirement. The graph below shows the impact of the first contribution date on the average IRRs of data set. It gives insights into why some savers have outperformed others in terms of absolute returns. ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.isyData && _ctx.filters.yearSeg)
                ? (_openBlock(), _createBlock(_component_ISYChart, {
                    key: 0,
                    chartData: _ctx.isyData,
                    provider: _ctx.filters.provider,
                    priceTrack: _ctx.filters.priceTrackObject,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["chartData", "provider", "priceTrack", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_progress_circular, { indeterminate: "" })
            ])),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        (_ctx.filters.yearSeg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "section-title" }, [
                _createElementVNode("div", { class: "section-badge" }),
                _createTextVNode(" Impact of Start Date ")
              ], -1),
              _createElementVNode("div", { class: "section-content" }, " Scores vary over time. Viewing the experience of each joiner cohort helps understand pot adequacy at retirement. The graph below shows the impact of the first contribution date on the average scores of data set. It gives insights into why some savers have outperformed others in terms of absolute returns. ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.fetchingChartData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.isyData && _ctx.filters.yearSeg)
                ? (_openBlock(), _createBlock(_component_ScoreYearChart, {
                    key: 0,
                    chartData: _ctx.isyData,
                    provider: _ctx.filters.provider,
                    priceTrack: _ctx.filters.priceTrackObject,
                    isSampleReport: _ctx.isSampleReport,
                    reportfilterRanges: _ctx.reportfilterRanges
                  }, null, 8, ["chartData", "provider", "priceTrack", "isSampleReport", "reportfilterRanges"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_progress_circular, { indeterminate: "" })
            ])),
        _createElementVNode("div", _hoisted_9, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}